import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { ImageInfo } from '@xFrame4/business/Types';
import client from '@xFrame4/business/GraphQlClient';
import EmailOptInFormGenerated, { EmailOptInFormGeneratedEntityManager } from './generated/EmailOptInForm.generated';
import { EmailOptInFormTranslation } from './EmailOptInFormTranslation';


export class EmailOptInFormEntityManager extends EmailOptInFormGeneratedEntityManager<EmailOptInFormTranslation, EmailOptInForm>
{
    constructor()
    {
        super({
            createEntity: () => new EmailOptInForm(),
            fields: [
                { name: 'image', type: BusinessEntityFieldType.Custom, inputProperty: 'imageFile', customGraphQl: imageInfoGraphQlDetails },
                { name: 'hasImage', type: BusinessEntityFieldType.Boolean, isInput: false }
            ]
        });
    }
}


export class EmailOptInForm extends EmailOptInFormGenerated<EmailOptInFormTranslation>
{
    static _manager: EmailOptInFormEntityManager;
    static get manager(): EmailOptInFormEntityManager
    {
        if (!this._manager) this._manager = new EmailOptInFormEntityManager();

        return this._manager;
    }

    /** Total count of confirmed entries for this form */
    contactFormEntryCount?: number;
    
    /** Count of confirmed entries by language */
    contactFormEntryCountsByLanguage?: { [key: string]: number };
    
    /** The image info for the email opt-in form. */
    image!: ImageInfo;
    /** Whether the entity has an image file stored in the media folder. */
    hasImage: boolean = false;
    /** The image file object to use for uploading. */
    imageFile?: File;

    /**
     * Creates a new email opt-in form entry.
     * Uses the create_email_opt_in_form_entry mutation to create a new entry.
     * Note: The mutation doesn't return the created entry, only success status.
     * IP address and user agent are captured server-side automatically.
     */
    async createEntry(email: string, name?: string, phone?: string): Promise<{ success: boolean; message?: string; needsConfirmation?: boolean }>
    {
        let { gql } = await import('@apollo/client');

        let mutation = `
            mutation CreateEmailOptInFormEntry($optinFormId: Int!, $email: String!, $name: String, $phone: String) {
                createEmailOptInFormEntry(optinFormId: $optinFormId, email: $email, name: $name, phone: $phone) {
                    success
                    message
                    needsConfirmation
                }
            }
        `;

        let variables = {
            optinFormId: this.id,
            email: email,
            name: name,
            phone: phone
        };

        try
        {
            let { data } = await client.mutate({
                mutation: gql(mutation),
                variables: variables
            });

            return {
                success: data?.createEmailOptInFormEntry?.success ?? false,
                message: data?.createEmailOptInFormEntry?.message,
                needsConfirmation: data?.createEmailOptInFormEntry?.needsConfirmation
            };
        }
        catch (error)
        {
            console.error('Error creating email opt-in form entry:', error);

            return {
                success: false,
                message: 'Network error'
            };
        }
    }
}


export default EmailOptInForm;